import { authenticationService } from '../services/auth.service';

const SLUG_STORAGE_KEY = 'app-url-slug';
export const SLUG_HEADER_NAME = 'x-tenant';

const appRootSegments = new Set([
  'cupons',
  'entrar',
  'nova-senha',
  'inicio',
  'membros',
  'secretaria',
  'sistema',
  'eventos',
  'reuniao',
  'calendario',
  'auditoria',
  'umadeub',
  'jovens',
  'campanhas',
  'pedidos',
  'meu-extrato',
  'nao-autorizado',
  'noticias',
  'aplicativo',
  'usuarios',
  'congregacoes'
]);

function getSafePathname(pathname?: string) {
  if (!pathname) {
    return '/';
  }

  const [path] = pathname.split(/[?#]/);

  if (!path) {
    return '/';
  }

  return path.startsWith('/') ? path : `/${path}`;
}

function persistSlug(slug: string | null) {
  if (slug) {
    localStorage.setItem(SLUG_STORAGE_KEY, slug);
    return slug;
  }

  localStorage.removeItem(SLUG_STORAGE_KEY);
  return null;
}

function logoutWhenSlugChanges(nextSlug: string) {
  authenticationService.removeUserLogged();

  const nextLoginPath = `/${nextSlug}/entrar`;

  if (window.location.pathname !== nextLoginPath) {
    window.location.href = nextLoginPath;
  }
}

export function getStoredSlug() {
  const storedSlug = localStorage.getItem(SLUG_STORAGE_KEY);

  if (!storedSlug || appRootSegments.has(storedSlug)) {
    localStorage.removeItem(SLUG_STORAGE_KEY);
    return null;
  }

  return storedSlug;
}

export function extractSlugFromPathname(pathname?: string) {
  const safePathname = getSafePathname(pathname);
  const [firstSegment] = safePathname.split('/').filter(Boolean);

  if (!firstSegment || appRootSegments.has(firstSegment)) {
    return null;
  }

  return firstSegment;
}

export function getCurrentSlug(pathname?: string) {
  const safePathname = getSafePathname(pathname ?? window.location.pathname);
  const detectedSlug = extractSlugFromPathname(safePathname);

  if (detectedSlug) {
    const storedSlug = getStoredSlug();

    if (storedSlug && storedSlug !== detectedSlug) {
      logoutWhenSlugChanges(detectedSlug);
    }

    return persistSlug(detectedSlug);
  }

  const storedSlug = getStoredSlug();

  if (storedSlug && safePathname !== `/${storedSlug}` && !safePathname.startsWith(`/${storedSlug}/`)) {
    return persistSlug(null);
  }

  return storedSlug;
}

export function getRouterBasename(pathname?: string) {
  const slug = getCurrentSlug(pathname);
  return slug ? `/${slug}` : undefined;
}

export function normalizeAppPath(pathname?: string) {
  const safePathname = getSafePathname(pathname ?? window.location.pathname);
  const slug = extractSlugFromPathname(safePathname) ?? getStoredSlug();

  if (!slug) {
    return safePathname;
  }

  if (safePathname === `/${slug}`) {
    return '/';
  }

  if (safePathname.startsWith(`/${slug}/`)) {
    const normalizedPath = safePathname.slice(slug.length + 1);
    return normalizedPath || '/';
  }

  return safePathname;
}

export function buildAppPath(path: string) {
  if (!path.startsWith('/')) {
    return path;
  }

  const slug = getCurrentSlug();

  if (!slug || path === `/${slug}` || path.startsWith(`/${slug}/`)) {
    return path;
  }

  return `${`/${slug}`}${path === '/' ? '' : path}`;
}